import React from 'react'
import FavoriteCard from '../components/PokemonCard'
import {useSelector} from 'react-redux'
import {
    useRouteMatch,
    Switch,
    Route
} from 'react-router-dom'
import Detail from './Detail'

export default function Favorite() {
    const pokemons = useSelector((state)=> state.pokemonReducer.favorites); //panggil data
    const {path} = useRouteMatch()

    return (
        <>
            <Switch>
                <Route path={`${path}/:pokemonId`}>
                    <Detail />
                </Route>
                <Route path={`${path}`}>
                    {pokemons.length > 0 ? 
                    <div>
                        <h2 className="ml-3" data-testid="pokemon-list-title" style={{textAlign:"center"}}>Pokemon Lists</h2>
                        <FavoriteCard pokemons={pokemons} />
                    </div>
                    : <h2 data-testid="empty-fave-title" style={{textAlign:"center",marginTop:"16px"}}>Please add your favorite pokemons</h2>
                }
                </Route>
            </Switch>
        </>
    )
}